/**
 * ./common.service.ts
 *
 * To load these, you must import like so: import { authApi } from "./";
 * This ensures the global error handler interceptor is loaded.
 * if you load it like so: import { authApi } from "./common.service.ts", it by-passes the interceptor
 */

import axios from "axios";
import { REST_URL } from "common/constants";
import { MenuStats } from "types/model.types";

export const authApi = axios.create({
  baseURL: REST_URL,
  withCredentials: true, // sends cookies
});

export const publicApi = axios.create({
  baseURL: REST_URL,
  // no credentials sent
});
/**
 * Safe api wrapper
 * 
 * usage: const resp = await safeApiCall(yourApiFunction(...));

 * @param promise 
 * @returns 
 */
export const safeApiCall = async <T>(promise: Promise<T>, label?: string) => {
  //TODO uncomment below line to get stack trace of calling method
  // const stack = label ?? new Error().stack;
  // console.log("safeApiCall called from:", stack);

  try {
    const result = await promise;

    // Detect backend "soft errors" that return 200 OK but contain an error payload
    if (result && (result as any)?.data?.status === 401) {
      // Treat it like a real HTTP error
      window.location.href = "/";
      return;
    }

    return result;

    // return await promise;
    // const data = await promise;
    // return { data, error: null };
  } catch (error: any) {
    const status = error?.response?.status;
    const method = error?.config?.method?.toLowerCase();
    // check if it's a 401: Unauthorized, 403: Forbidden - this can happen if session time out, so we redirect user to home page and force them to log back in

    // 🚫 Never redirect on GET requests
    if (method !== "get" && (status === 401 || status === 403)) {
      window.location.href = "/"; // Fallback if navigate isn't available
    }

    //    return error;
    return error.response?.data; // suppress error - leave this as it's handled by global handler in interceptor.ts.
    // we need this catch to prevent it bubbling up further and show the ugly default Uncaught runtime errors:.. message
  }
};

export const getMenuStats = async (): Promise<void | MenuStats> => {
  const { data } = await authApi.post<MenuStats>("/menuStats", {});
  return data;
};
